module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 center col-sm-12 col-md-12 col-lg-4 col-lg-offset-4"
  }, [_c('div', {
    staticClass: "center well no-padding"
  }, [_c('form', {
    staticClass: "smart-form client-form",
    attrs: {
      "action": "index.html",
      "id": "login-form"
    }
  }, [_vm._m(0), _vm._v(" "), _c('login-form')], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('i', {
    staticClass: "fa fa-lg fa-lock"
  }), _vm._v(" ÁREA RESTRITA\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18994d9b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auth/LoginPage.vue
// module id = 968
// module chunks = 1